import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, NgModel, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../shared/auth/auth.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {LocalStorageService} from '../../../shared/storage/local-storage.service';
import {NgbModal, ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-customer-login',
  templateUrl: './customer-login.component.html',
  styleUrls: ['./customer-login.component.scss']
})
export class CustomerLoginComponent implements OnInit {

  loginFormSubmitted = false;
  otpformSubmitted = false;
  authCodeSubmitted = false;
  isLoginFailed = false;
  showOTP = false;
  showLogin = true;
  showQRCode = false;
  showTwofa = false;
  closeResult: string;
  userData: any;
  userreponse: any;
  loginForm = new UntypedFormGroup({
    number: new UntypedFormControl('', [Validators.required, Validators.pattern('[0-9{10}|[0-9]{9}')]),
  });

  verifyOTp = new UntypedFormGroup({
    otp: new UntypedFormControl('', [Validators.required, Validators.pattern('[0-9]{4}')]),
  });

  googleAuthCode = new UntypedFormGroup({
    authCode: new UntypedFormControl('', [Validators.required]),
  })

  registeruser = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    streetAddress: new FormControl('', Validators.required),
    subUrb: new FormControl('', Validators.required),
    state: new FormControl('', Validators.required),
    country: new FormControl('', Validators.required),
    postcode: new FormControl('', Validators.required),
    // number: new FormControl('', [Validators.required]),
    // license: new FormControl('', [Validators.required]),
    pharmacy: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    confirm_password: new FormControl('', [Validators.required]),
    medicareNumber: new FormControl('', [Validators.required]),
  });

  isformSubmitted = false;
  validateNumber = false;
  validatepostalCode = false;
  validateMedicareNum = false;
  pharmacyList: any[] = [];
  platform: any;


  constructor(private router: Router, private authService: AuthService, private modalService: NgbModal,
              private spinner: NgxSpinnerService, private storage: LocalStorageService, private toastr: ToastrService,
              private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.platform = JSON.parse(localStorage.getItem('platform'));
    // history.pushState(null, '', location.href);
    // window.onpopstate = () => {
    //   history.go(1);
    // }
  }

  get lf() {
    return this.loginForm.controls;
  }

  get of() {
    return this.verifyOTp.controls;
  }

  get authf() {
    return this.googleAuthCode.controls;
  }

  // On submit button click
  onSubmit() {
    this.loginFormSubmitted = true;
    if (this.loginForm.invalid) {
      return;
    }

    const body = {
      number: '+61' + this.loginForm.value.number
    }
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });

    this.authService.loginPhone(body, this.platform).then(resp => {
      this.spinner.hide();
      this.toastr.success('OTP has sent to your registered Phone number', 'Message!', {
        positionClass: 'toast-top-center'
      });
      this.userreponse = resp;
    }).catch(err => {
      console.log(err);
    });
    this.showLogin = false;
    this.showOTP = true;
  }


  verify_OTP(content) {
    this.otpformSubmitted = true;
    if (this.verifyOTp.invalid) {
      return;
    }
    const body = {
      number: '+61' + this.loginForm.value.number,
      otp: this.verifyOTp.value.otp
    }
    this.authService.verify_otp(body, this.platform).then((resp: any) => {

      if (resp.status === 400) {
        this.toastr.error('Wrong OTP', 'Error!', {
          positionClass: 'toast-top-center'
        });
        this.showQRCode = false;
        this.showTwofa = false;
      } else {
        this.userData = resp;

        this.showOTP = false;
        this.showQRCode = true;
        this.showTwofa = true;
        // res?.qrCodeUrl

        if (resp?.user?.firstName === '') {
          this.open(content);
        }
        if (resp?.user?.twoFactorAuth?.enabled) {
          this.authService.generateQrCode(resp).then((res: any) => {
            document.querySelector('#qrcode').setAttribute('src', res.qrCodeUrl);
          }).catch(err => {
            console.log(err)
          });
        } else {
          this.router.navigate(['/dashboard'])
        }
      }
      this.showQRCode = true;
      this.showTwofa = true;
    }).catch(err => {
      this.toastr.error('Wrong OTP', 'Error!', {
        positionClass: 'toast-top-center'
      });
      this.showQRCode = false;
      this.showTwofa = false;
    });

  }


  open(content) {
    this.modalService.open(content, {windowClass: 'small-modal'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  verify_Two_fa() {
    const user = JSON.parse(localStorage.getItem('script-capture'));
    this.authCodeSubmitted = true;
    if (this.googleAuthCode.invalid) {
      return;
    }
    const body = {
      six_digit_code: this.googleAuthCode.value.authCode
    }
    this.authService.verify_two_faAuth(user, body).then(async (resp: any) => {
      if (resp.valid) {
        this.router.navigate(['/dashboard']);
      } else {
        this.toastr.error('Invalid Two Fa code', 'Error!', {
          positionClass: 'toast-top-center'
        });
      }

    }).catch(err => {
      this.toastr.error('Verification failed', 'Error!', {
        positionClass: 'toast-top-center'
      });
    })
  }


  validateMobile(event: any) {
    const pattern = /^[0-9]{10}$/;
    if (!pattern.test(event.target.value)) {
      this.validateNumber = true;
      return;
    }
    this.validateNumber = false;
  }

  validatePostCode(event: any) {
    const pattern = /^[0-9]{6}$/;
    if (!pattern.test(event.target.value)) {
      this.validatepostalCode = true;
      return;
    }
    this.validatepostalCode = false;
  }


  validateMedicareNumber(event: any) {
    const pattern = /^[0-9]{10}$/;
    if (!pattern.test(event.target.value)) {
      this.validateMedicareNum = true;
      return;
    }
    this.validateMedicareNum = false;
  }

  registerUser() {
    const user = JSON.parse(localStorage.getItem('script-capture'));
    const body = [];
    this.isformSubmitted = true;
    if (this.registeruser.invalid) {
      return;
    }
    if (this.registeruser.controls['password'].value !== this.registeruser.controls['confirm_password'].value) {
      this.toastr.clear();
      this.toastr.error('Password mismatch', 'Error!', {
        positionClass: 'toast-top-center'
      });
      return;
    }
    for (const key in this.registeruser.controls) {
      if (this.registeruser.controls[key].dirty) {
        body.push({propName: key, value: this.registeruser.controls[key].value});
      }
    }
    console.log(body);
    // this.authService.editUser(user,body).then(rep => {
    //   console.log(rep);
    // }).catch(err => {
    //   console.log(err);
    // });
  }


  tryAgain() {
    this.showLogin = true;
    this.showOTP = false;
    this.verifyOTp.reset();
    this.showQRCode = false;
    this.showTwofa = false;
    this.loginFormSubmitted = false;
  }
}
